import {createApp} from 'vue'
import Store from 'store'
import ReceiptComponent from './ReceiptComponent.options'

const el = '.nlx-component--receipt-component'
const DOM = document.querySelector(el)

if(DOM){

    const insertedComment = DOM.querySelector('#user_comment') ? DOM.querySelector('#user_comment').dataset.comment : ''
    const insertedRef = DOM.querySelector('#user_comment') ? DOM.querySelector('#user_comment').dataset.externalreference : ''

    const component = createApp(ReceiptComponent,{insertedComment,insertedRef}).use(Store)

    ReceiptComponent.template = DOM.outerHTML
    component.mount(el)
}

